import React, { useState, useEffect } from 'react';
import { CheckCircle2, Clock, TrendingUp, Target } from 'lucide-react';
import { getFunnelStages, updateFunnelStage } from '../services/api';

const stageIcons = { 1: Target, 2: Clock, 3: TrendingUp, 4: CheckCircle2 };

function FunnelStageSelector({ conversationId, currentStageId, onChange }) {
  const [stages, setStages] = useState([]);
  const [selected, setSelected] = useState(currentStageId);

  useEffect(() => {
    getFunnelStages().then(res => setStages(res.data)).catch(console.error);
  }, []);

  useEffect(() => { setSelected(currentStageId); }, [currentStageId]);

  const handleChange = async (stageId) => {
    setSelected(stageId);
    try {
      await updateFunnelStage(conversationId, stageId);
      if (onChange) onChange(stageId);
    } catch (err) { alert('Erro ao atualizar funil'); }
  };

  return (
    <div className="p-4 border-b border-gray-100">
      <h3 className="font-bold text-gray-900 text-sm mb-3 flex items-center gap-2">
        <TrendingUp size={16} className="text-purple-500" /> Funil de Vendas
      </h3>
      {/* ⭐ NOVO: em telas menores (painel estreito), vira um dropdown — só volta
          pra grade de botões em telas bem grandes (2xl), onde tem espaço sobrando */}
      <select
        value={selected || ''}
        onChange={e => handleChange(Number(e.target.value))}
        className="2xl:hidden w-full p-2.5 border border-gray-200 rounded-xl text-xs font-medium text-gray-700 bg-white outline-none focus:ring-2 focus:ring-purple-500"
      >
        <option value="" disabled>Selecione a etapa...</option>
        {stages.map(stage => (
          <option key={stage.id} value={stage.id}>{stage.name}</option>
        ))}
      </select>
      <div className="hidden 2xl:grid grid-cols-2 gap-2">
        {stages.map(stage => {
          const Icon = stageIcons[stage.position] || Target;
          const isActive = selected === stage.id;
          return (
            <button key={stage.id} onClick={() => handleChange(stage.id)}
              className={`flex items-center gap-2 p-2.5 rounded-xl border text-xs font-medium transition-all ${
                isActive ? 'bg-purple-50 border-purple-200 text-purple-700' : 'bg-white border-gray-100 text-gray-600 hover:bg-gray-50'
              }`}>
              <Icon size={16} className={isActive ? 'text-purple-600' : 'text-gray-400'} />
              {stage.name}
            </button>
          );
        })}
      </div>
    </div>
  );
}
export default FunnelStageSelector;